theme.Currency = (function(){
  var moneyFormat = $('#shop_currency_val').text();
  function formatMoney(cents, format){
    if(typeof cents === 'string'){
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);
    function formatWithDelimiters(number, precision, thousands, decimal){
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if(isNaN(number) || number == null){
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      return dollarsAmount + centsAmount;
    }
    switch(formatString.match(placeholderRegex)[1]){
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $){
  //alert("testing");
  var shop_currency = $('#shop_currency_val').text();
  
  'use strict';
  var init, loadCart;
  var settings, isUpdating, $body;
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, validateQty;

  init = function(options){
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#cart_container_id',
      addToCartSelector  : 'button[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : shop_currency,
      disableAjaxCart    : false,
      enableQtySelectors : false
    };
    
    $.extend(settings, options);
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $body = $('body');
    isUpdating = false;
    if(!settings.disableAjaxCart && $addToCart.length){
      formOverride();
    }
    adjustCart();
  };
  loadCart = function(){
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };
  updateCountPrice = function(cart){
    if($cartCountSelector){
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      if(cart.item_count === 0){
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if($cartCostSelector){
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, ''));
    }
  };
  formOverride = function(){
    $formContainer.on('submit', function(evt){
      evt.preventDefault();
      wc_theme_source.lib.addtocart_form(evt.target, itemAddedCallback, itemErrorCallback)
    });
  };
  itemAddedCallback = function(product){
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };
  itemErrorCallback = function(XMLHttpRequest, textStatus){
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');
    if(!!data.message){
      if(data.status == 422){
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };
  cartUpdateCallback = function(cart){
    updateCountPrice(cart);
    buildCart(cart);
  };
  buildCart = function(cart){
    $cartContainer.empty();
    if(cart.item_count === 0){
      $cartContainer.append('<div class="empty_cart_image_cls"><img src="//britishequine.co.uk/cdn/shop/t/2/assets/cart-empty.jpg?v=172028857923199254451783006900" alt="empty_cart_image" alt="empty_cart_image" ></div><h5 class="empty_cart_slide_cls">' + "Your cart is currently empty." + '</h5>');
      cartCallback(cart);
      return;
    }
    var items = [], item = {}, data = {}, source = $("#CartTemplate").html(), template = Handlebars.compile(source);
    $.each(cart.items, function(index, cartItem){
      if(cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else{
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      if(cartItem.properties !== null){
        $.each(cartItem.properties, function(key, value){
          if(key.charAt(0) === '_' || !value){
             delete cartItem.properties[key];
           }
        });
      }
      item = {
        key: cartItem.key,
        line: index + 1,
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, shop_currency),
        discountedPrice: Shopify.formatMoney((cartItem.price - (cartItem.total_discount/cartItem.quantity)), shop_currency) ,
        discounts: cartItem.discounts,
        discountsApplied: cartItem.price === (cartItem.price - cartItem.total_discount) ? false : true,
        vendor: cartItem.vendor
      };
      items.push(item);
    });
    var ajax_cart_countdown_timer = '';ajax_cart_countdown_timer = true;data = {
      items: items,
      note: cart.note,
      ajax_cart_countdown_timer: ajax_cart_countdown_timer,
      totalPrice: Shopify.formatMoney(cart.total_price, shop_currency),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "Translation missing: en.cart.general.savings_html".replace('[savings]', theme.Currency.formatMoney(cart.total_discount, settings.moneyFormat))
    };
    $cartContainer.append(template(data));
    
    if($('.ks_cart_counter_ajax').length > 0){
      var ajax_true_icon = 'fas fa-lock';
      var ajax_timer_text = '<i class="'+ajax_true_icon+'"></i> Your cart is saved for the next:';
      var ajax_expiry_text = 'Please proceed to checkout now';
      var ajax_timer_cms_val = '10';
      var ajax_timer_in_minute = parseInt(ajax_timer_cms_val);   
      function ajax_createCookie(a, b, c){
        if(c){
          var d = new Date;
          d.setTime(d.getTime() + c * 60 * 1e3);
          var e = "; expires=" + d.toUTCString()
          } else var e = "";
        document.cookie = a + "=" + b + e + "; path=/"
      }
      function ajax_readCookie(a){
        for(var b = a + "=", c = document.cookie.split(";"), d = 0; d < c.length; d++){
          for (var e = c[d]; " " == e.charAt(0);) e = e.substring(1, e.length);
          if(0 == e.indexOf(b)) return e.substring(b.length, e.length);
        }
        return null
      }
      function ajax_eraseCookie(a){
        ajax_createCookie(a, "", -1)
      }
      function ajax_crtmedir(a){
        var b = document.createDocumentFragment(), c = document.createElement("div");
        for(c.innerHTML = a; c.firstChild;) b.appendChild(c.firstChild);
        return b
      }
      function ajax_startTimer(start, duration, display){
        var diff, minutes, seconds;
        function ajax_timer(){
          diff = duration - (((Date.now() - start) / 1000) | 0);
          minutes = (diff / 60) | 0;
          seconds = (diff % 60) | 0;
          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;
          display.textContent = minutes + ":" + seconds;
          if(diff <= 0){
            clearInterval(inti);
            document.getElementById("ajax_countdownhere").innerHTML = ajax_expiry_text;
            start = Date.now() + 1000;
          }
        };
        ajax_timer();
        var inti = setInterval(ajax_timer, 1000);                    
      }                  
      var ajax_pdm = ajax_crtmedir('<div class="ajax_countdownholder"><div id="ajax_countdownhere">'+ajax_timer_text+'<span id="ajax_time"></span></div></div>');
      document.getElementsByClassName('ks_cart_counter_ajax')[0].innerHTML = "";
      document.getElementsByClassName('ks_cart_counter_ajax')[0].appendChild(ajax_pdm);
      var ajax_dolzina = ajax_timer_in_minute;
      var ajax_ten = 60 * ajax_dolzina;
      var ajax_starttime = Date.now();
      var ajax_xcnt = ajax_readCookie('ajax_prtcntdwn');
      if(ajax_xcnt){
        if(ajax_starttime < ajax_xcnt){
          ajax_ten = (ajax_xcnt - ajax_starttime) / 1000;
        } else{
          ajax_eraseCookie('ptcntdwn');
          ajax_createCookie('ajax_prtcntdwn', Date.now() + (ajax_ten * 1000), ajax_ten + 1);
        }
      } else{
        ajax_createCookie('ajax_prtcntdwn', Date.now() + (ajax_ten * 1000), ajax_ten + 1);
      }
      ajax_display = document.querySelector('#ajax_time');
      ajax_startTimer(ajax_starttime, ajax_ten, ajax_display);
    }
    
    cartCallback(cart);
  };

  cartCallback = function(cart){
    $body.trigger('ajaxCart.afterCartLoad', cart);
    wc_theme_source.lib.on_cart_update(cart);
    if(window.Shopify && Shopify.StorefrontExpressButtons){
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function(){
    $body.on('click', '.ajaxcart__qty-adjust', function(){
      if(isUpdating){
        return;
      }
      var $el = $(this), line = $el.data('line'), $qtySelector = $el.parents('ul.QuantityBox').find('.ajaxcart__qty-num'), qty = parseInt($qtySelector.val());
      var qty = validateQty(qty);
      if($el.hasClass('ajaxcart__qty--plus')){
        qty += 1;
      } else{
        qty -= 1;
        if(qty <= 0) qty = 0;
      }
      if(line){
        updateQuantity(line, qty);
      } else{
        $qtySelector.val(qty);
      }    
    });
    
    $body.on('click', '.cart_remove_item', function(){
      var line = $(this).attr('data-line');
      wc_theme_source.lib.cart_remove_item(line, adjustCartCallback)
    });
    $body.on('change', '.ajaxcart__qty-num', function(){
      if(isUpdating){
        return;
      }
      var $el = $(this), line = $el.data('line'), qty = parseInt($el.val().replace(/\D/g, ''));
      var qty = validateQty(qty);
      if(line){
        updateQuantity(line, qty);
      }
    });
    $body.on('submit', 'form.ajaxcart', function(evt){
      if(isUpdating){
        evt.preventDefault();
      }
    });
    $body.on('focus', '.ajaxcart__qty-adjust', function(){
      var $el = $(this);
      setTimeout(function(){
        $el.select();
      }, 50);
    });
    function updateQuantity(line, qty){
      isUpdating = true;
      var $row = $('.Quantity_cart_slider[data-line="' + line + '"]').addClass('is-loading');
      if(qty === 0){
        $row.parent().addClass('is-removed');
      }
      setTimeout(function(){
        wc_theme_source.lib.cart_change_item(line, qty, adjustCartCallback);
      }, 250);
    }
  };
  adjustCartCallback = function(cart){
    updateCountPrice(cart);
    setTimeout(function(){
      wc_theme_source.lib.get_cart(buildCart);
      isUpdating = false;
    }, 150)
  };
  validateQty = function(qty){
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)){} else{
      qty = 1;
    }
    return qty;
  };
  module = {
    init: init,
    load: loadCart
  };
  return module;
}(ajaxCart || {}, jQuery));